var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowRight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0119 8.35378L9.51186 12.8538C9.41804 12.9476 9.29079 13.0003 9.15811 13.0003C9.02543 13.0003 8.89818 12.9476 8.80436 12.8538C8.71054 12.76 8.65783 12.6327 8.65783 12.5C8.65783 12.3674 8.71054 12.2401 8.80436 12.1463L12.4512 8.50003H2.65811C2.5255 8.50003 2.39833 8.44736 2.30456 8.35359C2.21079 8.25982 2.15811 8.13264 2.15811 8.00003C2.15811 7.86743 2.21079 7.74025 2.30456 7.64648C2.39833 7.55271 2.5255 7.50003 2.65811 7.50003H12.4512L8.80436 3.85378C8.71054 3.75996 8.65783 3.63272 8.65783 3.50003C8.65783 3.36735 8.71054 3.2401 8.80436 3.14628C8.89818 3.05246 9.02543 2.99976 9.15811 2.99976C9.29079 2.99976 9.41804 3.05246 9.51186 3.14628L14.0119 7.64628C14.0583 7.69272 14.0952 7.74786 14.1204 7.80856C14.1456 7.86926 14.1585 7.93433 14.1585 8.00003C14.1585 8.06574 14.1456 8.13081 14.1204 8.1915C14.0952 8.2522 14.0583 8.30735 14.0119 8.35378Z",
    fill: "#06030B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/ArrowRightBlack.4775cf1fa63bb70b7b3e514385f246ac.svg";
export { ForwardRef as ReactComponent };